import { inject, type InjectionKey } from "vue";
import type { CustomerSession } from "./types";

export const customerSessionKey: InjectionKey<CustomerSession> = Symbol("customer-session");

export function useCustomerSession(): CustomerSession {
  const session = inject(customerSessionKey);
  if (!session) {
    throw new Error("Customer session not installed. Did you forget app.provide(customerSessionKey, ...) in main.ts?");
  }
  return session;
}
